import { addNamespace } from '../../lib/helpers';

const a = addNamespace('filters');

export const TOGGLE_EXPANDED_FACETS = a('TOGGLE_EXPANDED_FACETS');
export const SET_FILTERS = a('SET_FILTERS');
export const UPDATE_FILTERS = a('UPDATE_FILTERS');
